import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import HighchartsVue from 'highcharts-vue'

import App from './App.vue'
import router from './router'


Vue.use(BootstrapVue)
Vue.use(HighchartsVue)

Vue.config.productionTip = false

Vue.filter('maxLength', function (value) {
  if (value.length < 20) {
    return value
  } else {
    return value.slice(0, 18) + '...'
  }
})
Vue.filter('sign', function(value) {
  if (value >= 0) {
    return '+ CHF ' + value
  } else {
    value *= -1
    return '- CHF ' + value
  }
});


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
